import { render, staticRenderFns } from "./UserDetailView.vue?vue&type=template&id=5e6a0d1d&"
import script from "./UserDetailView.vue?vue&type=script&lang=ts&"
export * from "./UserDetailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports